import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api, { formatApiError } from "../api";
import { BrutalButton, BrutalInput, BrutalTextarea } from "./Brutal";
import { toast } from "sonner";

export default function RestockRequestDialog({ product, onClose, onSubmitted }) {
  const { t } = useTranslation();
  const suggested = Math.max(1, (product.starting_stock || 0) - (product.current_stock || 0));
  const [quantity, setQuantity] = useState(suggested);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/restock-requests", {
        product_id: product.id,
        quantity: Number(quantity) || null,
        note: note.trim(),
      });
      toast.success(t("restock.sent"));
      onSubmitted?.();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white border border-zinc-200 rounded-xl shadow-xl p-6 w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
        data-testid="restock-dialog"
      >
        <h2 className="text-2xl font-semibold mb-1">{t("restock.dialog_title")}</h2>
        <p className="text-sm text-zinc-600 mb-4">{t("restock.dialog_subtitle", { name: product.name })}</p>

        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="block text-xs font-semibold mb-1">{t("restock.how_many")}</label>
            <BrutalInput
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              data-testid="restock-quantity-input"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold mb-1">{t("restock.note_optional")}</label>
            <BrutalTextarea
              rows={2}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder={t("restock.note_placeholder")}
              data-testid="restock-note-input"
            />
          </div>
          <div className="flex gap-3 pt-2">
            <BrutalButton type="button" variant="secondary" className="flex-1" onClick={onClose}>
              {t("common.cancel")}
            </BrutalButton>
            <BrutalButton
              type="submit"
              className="flex-1"
              disabled={busy}
              data-testid="restock-submit"
            >
              {busy ? t("restock.sending") : t("restock.send_request")}
            </BrutalButton>
          </div>
        </form>
      </div>
    </div>
  );
}
